import { User } from "@/types/auth";

export function getPageId() {
    let userStr = localStorage.getItem('user');
    if (userStr) {
        let userJson = JSON.parse(userStr) as User;
        return userJson.facebookPage?.pageId ?? 0;
    }
    return "";

}